<template>
  <div class="header">
    <Msg />
    <div class="header_item">
      <div class="navigation">
        <div class="hearder-my-wrapper">
          <div class="my">
            <span
              class="downapp"
              @mouseover="onqrmouseover"
              @mouseleave="onqrmouseleave"
              @
            >
              <i class="el-icon-download" />下载APP
              <div class="hearder-qr-wrapper" v-if="isshowdownqrapp">
                <div class="hearder-qr J_Module" data-name="qr">
                  <div class="qr">
                    <div class="qr-bd clearfix">
                      <!-- <span id="mtb" class="h">手机APP</span> -->
                      <img
                        class="qrcode"
                        src="data:image/png;base64,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"
                        aria-labelledby="mtb"
                      />
                    </div>
                    <a
                      href="javascript:;"
                      target="_self"
                      class="J_QrFt qr-ft"
                      role="button"
                      aria-label="关闭二维码"
                      data-spm-click="gostr=/;locaid=d2016;name=二维码关闭按钮"
                    >
                    </a>
                  </div>
                </div>
              </div>
            </span>
          </div>
        </div>
        <div class="main-nav__logo margin_left_right">
          <a href="/">
            <img
              class="main-nav__logo__img"
              src="../assets/img/logo-w.png"
              width="152"
              height="56"
          /></a>
          <div class="location" @click="onshowlocation_dialog">
            <img
              src="../assets/img/location_img.png"
              style="width:20px;height:20px;margin-right:5px;"
            />
            <div class="location_city">{{ cityname }}</div>
          </div>
          <el-amap
            vid="amapDemo"
            v-show="false"
            :center="center"
            :zoom="zoom"
            class="amapstyle"
            :events="events"
          >
            <el-amap-marker
              v-for="(marker, index) in markers"
              :position="marker"
              :key="index"
            ></el-amap-marker>
          </el-amap>

          <div class="location_dialog" v-show="islocation_dialog">
            <!-- 城市 -->
            <el-tabs v-model="activeName" type="card">
              <el-tab-pane label="热门城市" name="first">
                <div class="currentcity" v-if="currcityitem.id > 0">
                  <span>当前定位城市：</span
                  ><span
                    class="cityname"
                    @click="onsetcity(currcityitem)"
                    :data-id="currcityitem.id"
                    >{{ locationcity }}</span
                  >
                </div>
                <div id="myTabContent" class="tab-content">
                  <div class="tab-pane fade in active" id="hotcity">
                    <span
                      @click="onsetcity(jtem)"
                      v-for="jtem in HOT_arr"
                      :key="jtem.id"
                      :data-id="jtem.id"
                      >{{ jtem.areaname }}</span
                    >
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="ABCDEF" name="second">
                <div id="myTabContent" class="tab-content">
                  <div class="tab-pane fade" id="af">
                    <ul class="clearfix">
                      <li v-for="(item, index) in AF_arr" :key="index">
                        <div class="pick-left fl">{{ item.code }}</div>
                        <div class="pick-right fl">
                          <span
                            @click="onsetcity(jtem)"
                            v-for="(jtem, jndex) in item.citylist"
                            :key="jndex"
                            :data-id="jtem.id"
                            >{{ jtem.areaname }}</span
                          >
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="GHIJKLM" name="third">
                <div id="myTabContent" class="tab-content">
                  <div class="tab-pane fade" id="gm">
                    <ul class="clearfix">
                      <li v-for="(item, index) in GL_arr" :key="index">
                        <div class="pick-left fl">{{ item.code }}</div>
                        <div class="pick-right fl">
                          <span
                            @click="onsetcity(jtem)"
                            v-for="(jtem, jndex) in item.citylist"
                            :key="jndex"
                            :data-id="jtem.id"
                            >{{ jtem.areaname }}</span
                          >
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="NPQRST" name="fourth">
                <div id="myTabContent" class="tab-content">
                  <div class="tab-pane fade" id="nt">
                    <ul class="clearfix">
                      <li v-for="(item, index) in MR_arr" :key="index">
                        <div class="pick-left fl">{{ item.code }}</div>
                        <div class="pick-right fl">
                          <span
                            @click="onsetcity(jtem)"
                            v-for="(jtem, jndex) in item.citylist"
                            :key="jndex"
                            :data-id="jtem.id"
                            >{{ jtem.areaname }}</span
                          >
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="WXYZ" name="five">
                <div id="myTabContent" class="tab-content">
                  <div class="tab-pane fade" id="wz">
                    <ul class="clearfix">
                      <li v-for="(item, index) in SZ_arr" :key="index">
                        <div class="pick-left fl">{{ item.code }}</div>
                        <div class="pick-right fl">
                          <span
                            @click="onsetcity(jtem)"
                            v-for="(jtem, jndex) in item.citylist"
                            :key="jndex"
                            :data-id="jtem.id"
                            >{{ jtem.areaname }}</span
                          >
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="nav_item">
          <!-- <router-link to="/" :class="{ active: titleurl == 'homepage' }">
            <span>首页</span>
          </router-link> -->
          <!-- <router-link to="/newhouse" :class="{ active: titleurl == 'newhouse' }">
            <span>新房</span>
          </router-link>
          <router-link to="/secondhouse" :class="{ active: titleurl == 'secondhouse' }">
            <span>二手房</span>
          </router-link>
          <router-link to="/jobwanted" :class="{ active: titleurl == 'jobwanted' }">
            <span>求职</span>
          </router-link>
          <router-link to="/recruit" :class="{ active: titleurl == 'recruit' }">
            <span>招聘</span>
          </router-link>
          <router-link to="/product/special" :class="{ active: titleurl == 'special' }">
            <span>自营</span>
          </router-link> -->
        </div>
      </div>
    </div>
    <!-- 登录对话框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="400px"
      @close="oncloselogindialog"
      :close-on-click-modal="false"
    >
      <!-- <div class="headerBox">
        <div class="headerBoxTitle">登录</div>
        <div class="headerBoxIcon" @click="closeDialog">x</div>
      </div> -->
      <div class="LoginForm">
        <div class="loginpassword" v-if="isloginpassword">
          <div class="LoginFormTitle">
            <span
              :class="isaccountlogin ? 'curr' : ''"
              @click="onshowaccountlogin(1)"
              >密码登录</span
            >
            <span
              :class="!isaccountlogin ? 'curr' : ''"
              @click="onshowaccountlogin(2)"
              >短信登录</span
            >
          </div>
          <div>
            <form
              v-if="isaccountlogin"
              action
              enctype="application/x-www-form-urlencoded"
              class="LoginFormBox"
            >
              <el-input
                type="text"
                autoComplete="off"
                placeholder="请输入手机号码"
                class="Formtext"
                v-model="formMess.useraccount"
              >
                <template slot="prepend"
                  ><i class="icon el-icon-user"></i
                ></template>
              </el-input>
              <el-input
                type="password"
                autoComplete="off"
                placeholder="密码"
                class="Formtext"
                v-model="formMess.userpassword"
              >
                <template slot="prepend"
                  ><i class="icon el-icon-lock"></i
                ></template>
              </el-input>
              <button class="loginBtn" @click="LoginTo" type="button">
                登录
              </button>
            </form>
            <form
              v-if="!isaccountlogin"
              action
              enctype="application/x-www-form-urlencoded"
              class="LoginFormBox"
            >
              <el-input
                type="text"
                autoComplete="off"
                placeholder="请输入手机号码"
                class="Formtext"
                v-model="formMess.useraccount"
              >
                <template slot="prepend"
                  ><i class="icon el-icon-user"></i
                ></template>
              </el-input>
              <el-input
                type="text"
                autoComplete="off"
                placeholder="验证码"
                class="Formtext sendcode"
                v-model="formMess.verifyCode"
              >
                <template slot="prepend"
                  ><i class="icon el-icon-mouse"></i
                ></template>
                <el-button slot="append" @click="getCode('formMess')">{{
                  codeMsg
                }}</el-button>
              </el-input>
              <button class="loginBtn" @click="LoginToBySms" type="button">
                登录
              </button>
            </form>
          </div>
          <div class="loginExplain">
            <router-link to="/user/register">
              注册账号
            </router-link>
            <router-link style="margin-left:15px" to="/user/findpwd">
              忘记密码
            </router-link>
          </div>
        </div>
        <div class="loginqrcode" v-if="!isloginpassword">
          <div class="LoginFormTitle"><span>扫码登录</span></div>
          <div>
            <div class="appLoginWait" style="display: block;">
              <div class="appLoginWaitInner">
                <div class="appCodeWrap">
                  <div class="appCodeBox">
                    <div class="appCode">
                      <img
                        class="appCodeImg"
                        v-if="isshowqrcode"
                        :src="qrcodesrc"
                        width="160"
                        height="160"
                      />
                      <img
                        class="appCodeLoading"
                        v-if="!isshowqrcode"
                        width="16"
                        height="16"
                        src="https://mimg.127.net/p/freemail/index/lib/img/loading_s.gif"
                        data-src="https://mimg.127.net/p/freemail/index/lib/img/loading_s.gif"
                      />
                    </div>

                    <div class="appCodeRefresh" v-if="isappCodeRefresh">
                      <div class="appCode-mask"></div>
                      <div class="appCode-wrap">
                        <p class="appCodeMsg" v-if="isappCodeMsg">
                          {{ appCodeMsg }}
                        </p>
                        <a
                          class="appCodeRefreshButton"
                          v-if="isappCodeRefreshButton"
                          @click="onappCodeRefreshButton"
                          >刷新二维码</a
                        >
                        <p class="appCodeMsgo" v-if="isappCodeMsgo">
                          {{ appCodeMsgo }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="u-scan-tips">
                    打开
                    <a href="JavaScript:;" rel="noopener norefferrer">
                      牛豆豆APP </a
                    >扫一扫登录
                  </div>
                </div>
              </div>
              <p class="appLoginTxt txt-err" style="display: none;"></p>
            </div>
          </div>
          <div class="loginExplain">
            <router-link to="/user/register">
              注册账号
            </router-link>
            <router-link style="margin-left:15px" to="/user/findpwd">
              忘记密码
            </router-link>
          </div>
        </div>
        <div class="corner-icon-view view-type-qrcode" v-if="isloginpassword">
          <i class="iconfont icon-qrcode" @click="onchangeloginpopup(false)">
          </i>
          <div class="login-tip">
            <div class="poptip">
              <div class="poptip-arrow"><em></em><span></span></div>
              <div class="poptip-content">扫码登录更安全</div>
            </div>
          </div>
        </div>
        <div
          class="corner-icon-view view-type-password"
          v-if="!isloginpassword"
        >
          <i class="iconfont icon-password" @click="onchangeloginpopup(true)">
          </i>
          <div class="login-tip">
            <div class="poptip">
              <div class="poptip-arrow"><em></em><span></span></div>
              <div class="poptip-content">密码安全登录</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import Msg from '@/components/msg.vue';
import Utils from '@/utils/unil.js';
import Utilcity from '@/utils/unilcity.js';
import {
  userlogin,
  extendlogingetloginqrcode,
  userlogout,
  usergetcurruserinfo,
  usersenduserloginsms,
  userloginbysms
} from '@/api/user';
import { extendloginqueryqrcodelogin } from '@/api/extendlogin';
import { cityjson } from '@/utils/cityjsonbye.js';
import { cityjsonhot } from '@/utils/cityjsonbyhot.js';
import Cookies from 'js-cookie';
import {
  getCookieByName,
  setCookieByName,
  removeCookieByName
} from '@/utils/helper';
export default {
  props: {
    titleurl: String,
    iscontactTel: Boolean
  },
  components: {
    Msg
  },
  data() {
    return {
      currcityitem: { id: 0, areaname: '' },
      locationcity: '定位中...',
      cityname: '定位中...',
      islocation_dialog: false,
      isshowdownqrapp: false,
      codeMsg: '获取验证码',
      second: 60,
      timer: null,
      isaccountlogin: true,
      isloginpassword: false,
      dialogVisible: false,
      citys: [],
      //登录表单
      formMess: {
        useraccount: '',
        userpassword: '',
        verifyCode: ''
      },
      // 用户id
      userAccount: '',
      // 用户的显示与隐藏
      UserBoolean: true,
      activeName: 'first',
      isshowqrcode: false,
      qrcodesrc: '',
      appCodeMsg: '',
      appCodeMsgo: '',
      isappCodeMsg: false,
      isappCodeMsgo: false,
      isappCodeRefresh: false,
      isappCodeRefreshButton: false,
      iTime: null,
      HOT_arr: [],
      AF_arr: [],
      GL_arr: [],
      MR_arr: [],
      SZ_arr: [],
      markers: [],
      center: [117.127665, 36.679559],
      zoom: 15,
      // address: '',
      lng: 117.127665,
      lat: 36.679559,
      address: '',
      addForm: {
        longitude: '',
        latitude: ''
      },
      events: {
        click(e) {
          return;
          self.markers = [];
          let { lng, lat } = e.lnglat;
          // self.addForm.longitude = lng
          // self.addForm.latitude = lat
          self.center = [lng, lat];
          self.markers.push([lng, lat]);
          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: 'all'
          });
          geocoder.getAddress([lng, lat], function(status, result) {
            if (status === 'complete' && result.info === 'OK') {
              if (result && result.regeocode) {
                self.form.address = result.regeocode.formattedAddress;
                self.form.LnglatAmap =
                  result.regeocode.crosses[0].location.lng +
                  ',' +
                  result.regeocode.crosses[0].location.lat;
                self.form.Adcode = result.regeocode.addressComponent.adcode;
                self.address = result.regeocode.formattedAddress;
                // self.form.gisCoord.city =
                //   result.regeocode.addressComponent.city;
                self.form.gisCoord.province =
                  result.regeocode.addressComponent.province;
                self.form.gisCoord.latitude =
                  result.regeocode.crosses[0].location.lat;
                self.form.gisCoord.longitude =
                  result.regeocode.crosses[0].location.lng;
                self.form.gisCoord.county =
                  result.regeocode.addressComponent.district;
                self.form.gisCoord.countyCode =
                  result.regeocode.addressComponent.adcode;
                self.form.gisCoord.cityCode =
                  result.regeocode.addressComponent.adcode.substring(0, 4) +
                  '00';
                self.form.gisCoord.provinceCode =
                  result.regeocode.addressComponent.adcode.substring(0, 2) +
                  '0000';
                self.form.gisCoord.srid = 'GCJ-02';
                self.$nextTick();
              }
            }
          });
        }
      }
    };
  },
  created() {
    const self = this;
    let accessToken = getCookieByName('access_token');
    if (accessToken) {
      this.userAccount = getCookieByName('user_account');
      this.UserBoolean = false;
    }
    this.keyupSubmit();
    this.citys = cityjson;
    this.HOT_arr = cityjsonhot;
    let num = 0;
    let AF = [];
    let GL = [];
    let MR = [];
    let SZ = [];
    for (let i in this.citys) {
      num++;
      if (num < 7) {
        AF.push(this.citys[i]);
      } else if (num <= 12) {
        GL.push(this.citys[i]);
      } else if (num <= 18) {
        MR.push(this.citys[i]);
      } else {
        SZ.push(this.citys[i]);
      }
    }
    this.AF_arr = AF;
    this.GL_arr = GL;
    this.MR_arr = MR;
    this.SZ_arr = SZ;
  },
  mounted() {
    // if (localStorage.getItem('cityname')) {
    //   this.cityname = localStorage.getItem('cityname');
    //   this.cityid = localStorage.getItem('cityid');
    // } else {
    //   this.cityname = '郑州市';
    //   this.cityid = '410100';
    // }
    this.ongetcity();
  },
  watch: {
    iscontactTel(newName, oldName) {
      if (newName == true) {
        this.dialogVisible = true;
      }
    }
  },
  methods: {
    refresh() {
      this.$parent.refreshdata();
    },
    location() {
      var self = this;
      var geolocation = new AMap.Geolocation({
        // 是否使用高精度定位，默认：true
        enableHighAccuracy: true,
        maximumAge: 0, //定位结果缓存0毫秒，默认：0
        showButton: true, //显示定位按钮，默认：true
        buttonPosition: 'LB', //定位按钮停靠位置，默认：'LB'，左下角
        buttonOffset: new AMap.Pixel(10, 20),
        showMarker: true,
        panToLocation: true,
        zoomToAccuracy: true,
        // 设置定位超时时间，默认：无穷大
        timeout: 5000
      });
      geolocation.getCurrentPosition();
      AMap.event.addListener(geolocation, 'complete', onComplete);
      AMap.event.addListener(geolocation, 'error', onError);
      function onComplete(data) {
        let cityName = data.addressComponent.city;
        let geocoder = new AMap.Geocoder({});
        //地理编码,返回地理编码结果，
        geocoder.getLocation(cityName, function(status, result) {
          if (status === 'complete' && result.info === 'OK') {
            let cityAdcode = result.geocodes[0].adcode;
            self.cityid = cityAdcode;
            localStorage.setItem('cityid', self.cityid);
            self.currcityitem = { id: self.cityid, areaname: cityName };
            localStorage.setItem('locationcity', cityName);
            localStorage.setItem(
              'currcityitem',
              JSON.stringify(self.currcityitem)
            );
            self.refresh();
          }
        });
        localStorage.setItem('cityname', self.cityname);

        setTimeout(function() {
          self.cityname = data.addressComponent.city;
          localStorage.setItem('cityname', self.cityname);

          self.locationcity = data.addressComponent.city;
        }, 100);
        self.cityname = data.addressComponent.city;
      }
      function onError(data) {
        // 失败 启用 ip定位
        AMap.plugin('AMap.CitySearch', function() {
          var citySearch = new AMap.CitySearch();
          citySearch.getLocalCity(function(status, result) {
            if (status === 'complete' && result.info === 'OK') {
              // 查询成功，result即为当前所在城市信息
              // console.log(result)
              self.center = [result.bounds.Gb.lng, result.bounds.Gb.lat];
              geocoder.getAddress(
                [result.bounds.Gb.lng, result.bounds.Gb.lat],
                function(status, result) {
                  if (status === 'complete' && result.info === 'OK') {
                    if (result && result.regeocode) {
                      self.cityname = data.addressComponent.city;
                      self.cityid = data.addressComponent.adcode;

                      let geocoder1 = new AMap.Geocoder({});
                      //地理编码,返回地理编码结果，
                      geocoder1.getLocation(cityName, function(status, result) {
                        if (status === 'complete' && result.info === 'OK') {
                          let cityAdcode = result.geocodes[0].adcode;
                          self.cityid = cityAdcode;
                          localStorage.setItem('cityid', self.cityid);
                        }
                      });

                      localStorage.setItem('cityname', self.cityname);
                      //localStorage.setItem('cityid', self.cityid);
                      // self.address = result.regeocode.formattedAddress;
                      self.$nextTick();
                    } else {
                      self.cityname = '郑州市';
                      self.cityid = '410100';
                      localStorage.setItem('cityname', self.cityname);
                      localStorage.setItem('cityid', self.cityid);
                    }
                  } else {
                    self.cityname = '郑州市';
                    self.cityid = '410100';
                    localStorage.setItem('cityname', self.cityname);
                    localStorage.setItem('cityid', self.cityid);
                  }
                }
              );
            }
            self.refresh();
          });
        });
      }
    },
    ongetcity() {
      var self = this;
      if (!localStorage.getItem('cityname')) {
        setTimeout(function() {
          self.location();
        }, 800);
      } else {
        self.cityname = localStorage.getItem('cityname');
        self.cityid = localStorage.getItem('cityid');
      }
      if (localStorage.getItem('currcityitem')) {
        let cityjson = JSON.parse(localStorage.getItem('currcityitem'));
        self.locationcity = cityjson.areaname;
        self.currcityitem = cityjson;
      } else {
        self.locationcity = '未定位到您的城市';
      }
    },
    onsetcity(item) {
      const self = this;
      this.islocation_dialog = false;
      localStorage.setItem('cityid', item.id);
      localStorage.setItem('cityname', item.areaname);
      this.cityname = localStorage.getItem('cityname');
      this.cityid = localStorage.getItem('cityid');
      Utilcity.$emit('cityid', localStorage.getItem('cityid'));
      self.refresh();
    },
    onshowlocation_dialog() {
      this.islocation_dialog = !this.islocation_dialog;
    },
    onqrmouseover() {
      this.isshowdownqrapp = true;
    },
    onqrmouseleave() {
      this.isshowdownqrapp = false;
    },
    changeInput() {
      var phone = /^[1]([3-9])[0-9]{9}$/;
      if (phone.test(this.formMess.useraccount)) {
        this.$message.error('请输入正确的手机号');
      }
    },
    getCode(formName) {
      this.dbget = true;
      if (this.formMess.useraccount == '') {
        this.$message.error('请输入手机号');
        return;
      }
      var phone = /^[1]([3-9])[0-9]{9}$/;
      if (!phone.test(this.formMess.useraccount)) {
        this.$message.error('请输入正确的手机号');
        return;
      }
      if (this.second != 60) {
        this.$message.error(`请${this.second}秒后重试`);
        return;
      }
      usersenduserloginsms({ userMobile: this.formMess.useraccount }).then(
        res => {
          if (res.data.code === 1) {
            this.$message({
              message: '发送成功',
              type: 'success'
            });
            this.codeMsg = `${this.second}s后重试`;
            this.timer = setInterval(() => {
              this.second--;
              this.codeMsg = `${this.second}s后重试`;
              if (this.second == 0) {
                clearInterval(this.timer);
                this.second = 60;
                this.codeMsg = '获取验证码';
              }
            }, 1000);
          } else {
            this.$message.error(res.data.message);
            //this.phone = false;
          }
        }
      );
      return;
    },
    onshowaccountlogin(v) {
      if (v == 1) {
        this.isaccountlogin = true;
      } else {
        this.formMess.useraccount = '';
        this.isaccountlogin = false;
        this.formMess.verifyCode = '';
      }
    },
    keyupSubmit() {
      document.onkeydown = e => {
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.LoginTo();
        }
      };
    },
    oncloselogindialog() {
      if (this.iTime) {
        clearInterval(this.iTime);
      }
      this.$emit('closeShow', false);
    },
    onappCodeRefreshButton() {
      if (this.iTime) {
        clearInterval(this.iTime);
      }
      this.onextendlogingetloginqrcode();
    },
    onchangeloginpopup(flag) {
      this.isloginpassword = flag;
      if (this.iTime) {
        clearInterval(this.iTime);
      }
      if (!flag) {
        this.onextendlogingetloginqrcode();
      }
      this.formMess.useraccount = '';
      this.formMess.verifyCode = '';
      this.formMess.userpassword = '';
    },
    gotomine() {
      if (this.userAccount != '') {
        let routeData = this.$router.resolve({
          path: '/order/list',
          query: {}
        });
        window.open(routeData.href, '_blank');
      } else {
        this.dialogVisible = true;
        this.onextendlogingetloginqrcode();
      }
    },
    gotoregister() {
      let routeData = this.$router.resolve({
        path: '/user/register',
        query: {}
      });
      window.open(routeData.href, '_blank');
    },
    goToLogin() {
      this.dialogVisible = true;
      this.onextendlogingetloginqrcode();
    },
    LoginTo() {
      let formData = new FormData();
      formData.append('useraccount', this.formMess.useraccount);
      formData.append('userpassword', this.formMess.userpassword);

      let baseUrl = process.env.VUE_APP_URL3;
      var that = this;
      axios.post(`${baseUrl}/user/userlogin`, formData).then(res => {
        if (res.data.code == 1) {
          setCookieByName('access_token', res.data.result.access_token);
          setCookieByName('user_account', res.data.result.user_account);
          setCookieByName('user_id', res.data.result.user_id);

          this.userAccount = res.data.result.user_account;
          this.UserBoolean = false;
          this.dialogVisible = false;
          location.reload();
        } else {
          this.$message.error(res.data.message);
          this.removeCookies();
          this.UserBoolean = true;
        }
      });
    },
    LoginToBySms() {
      let formData = new FormData();
      formData.append('userMobile', this.formMess.useraccount);
      formData.append('verifyCode', this.formMess.verifyCode);

      let baseUrl = process.env.VUE_APP_URL3;
      var that = this;
      axios.post(`${baseUrl}/user/userloginbysms`, formData).then(res => {
        if (res.data.code == 1) {
          setCookieByName('access_token', res.data.result.access_token);
          setCookieByName('user_account', res.data.result.user_account);
          setCookieByName('user_id', res.data.result.user_id);

          this.userAccount = res.data.result.user_account;
          this.UserBoolean = false;
          this.dialogVisible = false;
          location.reload();
        } else {
          this.$message.error(res.data.message);
          this.removeCookies();
          this.UserBoolean = true;
        }
      });
    },
    signOut() {
      userlogout().then(res => {
        // if (res.data.code === 1) {
        // }
        this.removeCookies();
        location.reload();
      });
    },
    removeCookies() {
      removeCookieByName('access_token');
      removeCookieByName('user_account');
      removeCookieByName('refresh_token');
      removeCookieByName('user_id');
      removeCookieByName('iscompanyauthsuccess');
    },
    // 关闭登录对话框
    closeDialog() {
      this.dialogVisible = false;
    },
    onextendlogingetloginqrcode() {
      this.isappCodeRefresh = false;
      let baseUrl = process.env.VUE_APP_URL3;
      var that = this;
      axios
        .get(`${baseUrl}/extendlogin/getloginqrcode`, {
          params: { requestid: this.requestid, t: Math.random() }
        })
        .then(res => {
          if (res.data.code == 1) {
            this.qrcodesrc =
              'data:image/png;base64,' + res.data.result.qrcodeBase64;
            this.isshowqrcode = true;
            this.requestid = res.data.result.requestid;
            this.onextendloginqueryqrcodelogin();
          }
        });
    },
    onextendloginqueryqrcodelogin() {
      axios.defaults.withCredentials = true;
      axios.defaults.crossDomain = true;
      axios.defaults.headers.post['Content-Type'] =
        'application/x-www-form-urlencoded';

      let baseUrl = '';
      if (process.env.VUE_APP_ENV === 'development') {
        baseUrl = process.env.VUE_APP_URL3;
      } else if (process.env.NODE_ENV === 'production') {
        baseUrl = process.env.VUE_APP_URL3;
      } else {
      }
      var that = this;
      axios
        .get(`${baseUrl}/extendlogin/queryqrcodelogin`, {
          params: { requestid: this.requestid, t: Math.random() }
        })
        .then(res => {
          if (res.data.code == 1) {
            if (res.data.result.status == -2) {
              that.isappCodeRefresh = true;
              that.isappCodeRefreshButton = true;
              that.appCodeMsg = '二维码已失效';
              that.isappCodeMsg = true;
              that.isappCodeMsgo = false;
              clearInterval(this.iTime);
            } else if (res.data.result.status == -1) {
              that.isappCodeRefresh = true;
              that.isappCodeRefreshButton = true;
              that.appCodeMsgo = '登录已取消';
              that.isappCodeMsg = false;
              that.isappCodeMsgo = true;
              clearInterval(this.iTime);
            } else if (res.data.result.status == 1) {
              that.isappCodeRefresh = true;
              that.isappCodeRefreshButton = false;
              that.appCodeMsgo = '已扫码';
              that.isappCodeMsgo = true;
              that.isappCodeMsg = false;
              this.iTime = setTimeout(() => {
                that.onextendloginqueryqrcodelogin();
              }, 1000);
            } else if (res.data.result.status == 2) {
              clearInterval(this.iTime);
              window.location.reload();
            } else {
              that.iTime = setTimeout(() => {
                that.onextendloginqueryqrcodelogin();
              }, 1000);
            }
          } else {
            that.isappCodeRefresh = true;
            that.isappCodeRefreshButton = true;
            that.appCodeMsg = '二维码已失效';
            that.isappCodeMsg = true;
            that.isappCodeMsgo = false;
            clearInterval(this.iTime);
          }
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../assets/style/header/header.css';
.header {
  border-bottom: 1px solid #e8e7e7;
  background-image: url('../assets/product/top_bg.png');
  background-size: 100% 100%;
}
.header_item {
  width: 1190px;
  margin: 0 auto;
}
.head__login {
  padding: 7px;
  border-bottom: 1px solid #eee;
}
.head__login .info {
  /* width: 1200px; */
  max-width: 1200px;
  text-align: right;
  margin: 0 auto;
}
.head__login span {
  text-decoration: none;
  color: #696969;
}
.head__login > a {
  margin-right: 10px;
  cursor: pointer;
  text-decoration: none;
  color: #696969;
  font-size: 10px;
}
.navigation {
  height: 88px;
  position: relative;
}
.navigation .nav_item a {
  color: #707070;
  text-align: center;
  font-size: 15px;
  margin-right: 50px;
  text-decoration: none;
  padding: 22px 0;
  font-size: 16px;
  font-weight: 700;
}
.navigation .nav_item .active {
  color: #228bff;
  border-bottom: 4px solid #228bff;
}
.navigation .nav_item {
  margin-left: 300px;
  position: absolute;
  top: 30px;
}
.LoginForm {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 370px;
}
.LoginFormTitle {
  margin-bottom: 25px;
  font-size: 16px;
  color: #333;
  text-align: left;
  padding-left: 30px;
  margin-top: 20px;
  font-weight: 600;
}
.LoginFormTitle span {
  display: inline-block;
  margin-right: 20px;
  cursor: pointer;
}
.LoginFormTitle span::after {
  content: '';
  display: inline-block;
  background: #fff;
  height: 3px;
  width: 1%;
}
.LoginFormTitle span.curr::after {
  content: '';
  display: inline-block;
  background: #333;
  width: 100%;
  height: 3px;
  position: relative;
  top: -5px;
  transition: all 0.2s;
}
.el-form-item .el-form-item__content {
  margin-left: 0;
}
.formName {
  width: 355px;
  height: 50px;
  margin-left: -70px;
}
.formNames {
  width: 355px;
  height: 50px;
  margin-left: -70px;
}
.LoginformItem1 {
  margin-bottom: 4px;
}
.loginBtn {
  width: 327px;
  height: 40px;
  background-image: linear-gradient(260deg, #5aa5ff, #0d7bff);
  border-radius: 5px;
  border: none;
  /* margin-left: -70px; */
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 600px;
  color: #fff;
  margin-top: 50px;
  cursor: pointer;
}
.loginBtn:hover {
  border: 0 none;
  outline: none;
  background-color: #0a6dda;
}
.loginBtn:focus {
  border: 0 none;
  outline: none;
  background-color: #0a6dda;
}
.loginExplain {
  width: 100%;
  height: 30px;
  text-align: center;
  line-height: 30px;
  margin-bottom: 35px;
  font-size: 12px;
  color: #f6671a;
}
.loginExplain:hover {
  color: #23527c;
  cursor: pointer;
}
.LoginFormBox {
  display: block;
  flex-direction: column;
  text-align: center;
  margin-top: 25px;
}
.Formtext {
  width: 325px;
  /* height: 50px; */
  border: 0;
  outline: none;
  /* margin-left: 10px; */
  background-color: rgba(0, 0, 0, 0);
  /* border-bottom: 1px solid #ccc; */
  font-size: 14px;
  margin-top: 14px;
}
.Formtext >>> .el-input-group__prepend {
  width: 10px;
}
.Formtext.sendcode >>> .el-input-group__append {
  cursor: pointer;
}
.headerBox {
  display: flex;
  justify-content: space-between;
  width: 400px;
  height: 40px;
  background-color: #bebebe;
  margin: -61px 0 50px -20px;
}
.headerBoxTitle {
  margin: 10px 0 0 16px;
}
.headerBoxIcon {
  margin: 10px 16px 0 0;
  font-size: 17px;
  font-weight: 600;
  color: #989898;
}
.headerBoxIcon:hover {
  color: #5f5f5f;
  cursor: pointer;
}
.header .hearder-my-wrapper {
  position: relative;
  right: 0px;
  float: right;
  padding: 22px 0;
  margin-top: 10px;
}
.header .hearder-my-wrapper span {
  margin-left: 20px;
  font-size: 15px;
  cursor: pointer;
  position: relative;
}
.header .hearder-my-wrapper span i {
  color: #fff;
  background: #ddd;
  width: 20px;
  height: 20px;
  font-size: 12px;
  border-radius: 100%;
  text-align: center;
  line-height: 20px;
  top: -2px;
  position: relative;
  margin-right: 6px;
}
.header .hearder-my-wrapper span.downapp {
  position: relative;
  cursor: pointer;
  z-index: 101;
  color: #003a77;
  padding: 8px;
  background: #fff;
  border-radius: 20px;
}
.header .hearder-my-wrapper span.red {
  color: #ff7100;
  margin-left: 10px;
}

.header .hearder-qr-wrapper {
  position: absolute;
  top: 22px;
  right: -13px;
}
.header .hearder-qr-wrapper .qr {
  position: relative;
  z-index: 2;
}
.header .hearder-qr-wrapper .qr .qr-bd {
  position: relative;
  cursor: pointer;
  display: block;
  text-align: center;
  width: 82px;
  height: 82px;
  color: #666;
  border: 1px solid #eee;
  background-color: #fff;
}
.header .hearder-qr-wrapper .qr .qr-bd span {
  line-height: 20px;
  margin: 4px auto 0;
  width: 78px;
}
.header .hearder-qr-wrapper .qr .qr-bd img {
  display: block;
  width: 82px;
  height: 82px;
}
.header .hearder-qr-wrapper .qr .qr-ft {
  position: absolute;
  top: 0;
  left: -16px;
  display: none;
  width: 14px;
  height: 14px;
  border: 1px solid #eee;
}
.header >>> .el-dialog__body {
  padding: 0px;
}
.header >>> .el-dialog__headerbtn {
  position: absolute;
  top: 0px;
  right: -50px;
  padding: 12px;
}
.header >>> .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  font-size: 25px;
}

.corner-icon-view .iconfont {
  position: absolute;
  right: 5px;
  top: 5px;
  font-size: 52px;
  line-height: 52px;
  cursor: pointer;
  color: #f40;
}
.corner-icon-view .iconfont.icon-qrcode {
  background-image: url('../assets/img/login-qcode.png');
  background-size: 100% 100%;
  width: 50px;
  height: 50px;
}
.corner-icon-view .iconfont.icon-password {
  background-image: url('../assets/img/login-password.png');
  background-size: 100% 100%;
  width: 50px;
  height: 50px;
}

.corner-icon-view .login-tip {
  position: absolute;
  top: 0;
  right: 45px;
  display: block;
}
.corner-icon-view .login-tip {
  top: 5px;
  right: 58px;
  width: 112px;
}
.corner-icon-view .poptip {
  line-height: 16px;
  position: relative;
  z-index: 9999;
  background-color: #fefcee;
  border: 1px solid #ff9000;
  padding: 5px 10px;
}
.corner-icon-view .login-tip .poptip {
  border: 1px solid #f3d995;
  background: #fefcee;
}
.corner-icon-view .poptip .poptip-arrow em,
.corner-icon-view .poptip .poptip-arrow span {
  position: absolute;
  *zoom: 1;
  width: 0;
  height: 0;
  border-color: hsla(0, 0%, 100%, 0);
  border-color: transparent \0;
  border-style: solid;
  overflow: hidden;
  top: 0;
  left: 0;
  border-left-color: #ff9000;
}
.corner-icon-view .poptip .poptip-arrow {
  position: absolute;
  z-index: 10;
  *zoom: 1;
  top: 8px;
  right: 0;
}
.corner-icon-view .poptip .poptip-arrow em {
  top: 0;
  left: 1px;
  border-left-color: #ff9000;
  border-width: 6px 0 6px 6px;
}
.corner-icon-view .poptip .poptip-arrow span {
  border-left-color: #fefcee;
  border-width: 6px 0 6px 6px;
}

.corner-icon-view .poptip .poptip-content {
  color: #ff9000;
  font-size: 12px;
  font-weight: 400;
}

.appLoginTab {
  font-size: 16px;
  color: #626262;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.appCodeWrap {
  margin-top: 6px;
  height: 128px;
  position: relative;
  text-align: center;
}
.appCodeBox,
.appCode-example {
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.appCode {
  margin: 0 auto;
  background: #fff;
  border: 0;
  box-shadow: 0 0 8px #c6c4ce;
  padding: 17px;
  width: 160px;
  height: 160px;
}
.appCodeLoading {
  /* position: relative; */
  top: 86px;
  left: 175px;
  border: 0;
  margin-top: 70px;
}
.appCodeRefresh {
  position: absolute;
  top: 0px;
  left: 108px;
  width: 176px;
  height: 183px;
  cursor: pointer;
}
.appCode-mask {
  height: 100%;
  background: #fff;
  opacity: 0.95;
  filter: alpha(opacity=95);
}
.appCode-wrap {
  position: absolute;
  top: 0;
  left: 4px;
  width: 100%;
  padding-top: 60px;
  text-align: center;
  color: #333;
  font-size: 14px;
  line-height: 1;
}
.appCode-wrap a {
  display: block;
  width: 100px;
  height: 36px;
  background-color: #ff6600;
  color: #fff;
  line-height: 36px;
  margin: 12px auto 0;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}
.appLoginWait {
  border-bottom: none;
  margin: 30px 0;
}
.appLoginWait .u-scan-tips {
  margin-top: 35px;
}
.appLoginWait .u-scan-tips a {
  color: #175199;
}
.appCodeMsgo {
  margin-top: 18%;
  font-size: 14px;
}
.currentcity {
  font-size: 14px;
  padding: 0 5px 5px;
}
.currentcity .cityname {
  color: #228bff;
  cursor: pointer;
}
.location_city {
  color: #ffffff;
}
</style>
